import { apolloClient } from "../../../apollo/graphql";
import { GET_ADDRESS_REGIONS } from "../../../apollo/queries/processes";

export function distinctRegions(regions: string[]): string[] {
  const seen = new Set<string>();
  const distinct: string[] = [];
  for (const region of regions) {
    const trimmed = region.trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    distinct.push(trimmed);
  }
  return distinct;
}

export async function fetchRegionOptions(
  search: string,
  take = 25,
): Promise<string[]> {
  const term = search.trim();
  const { data } = await apolloClient.query<{ addressRegions: string[] }>({
    query: GET_ADDRESS_REGIONS,
    variables: {
      search: term.length >= 1 ? term : undefined,
      take,
    },
    fetchPolicy: "network-only",
  });
  return distinctRegions(data?.addressRegions ?? []);
}
